export default "__VITE_ASSET__DWjSMlm$__"